import { styled, designTokens } from '@volkswagen-onehub/components-core';

interface TabProps {
  selected?: boolean;
}

interface BorderHighlightProps {
  yVal: number;
}

export const SideTabsWrapper = styled.div`
  display: flex;
  position: relative;
`;

export const TabsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.size.static200};
`;

export const Tab = styled.div<TabProps>`
  cursor: pointer;
  text-decoration: none;
  padding: ${(props) => props.theme.size.static400};
  color: ${(props) =>
    props.selected
      ? props.theme.colors.content.primary
      : props.theme.colors.content.tertiary};
  transition: color 0.3s ease;
  &:hover {
    color: ${(props) => props.theme.colors.content.active};
  }

  span {
    font-weight: ${(props) => (props.selected ? 'bold' : 'normal')};
  }
`;

export const Border = styled.div(
  ({ theme }) => `
  overflow: hidden;
  position: absolute;
  width: 4px;
  border-radius: 8px;
  background-color: ${theme.colors.border.divider};
  height: 100%;
`);

export const BorderHighlight = styled.div<BorderHighlightProps>`
  position: absolute;
  height: 90px;
  width: 4px;
  background-color: ${(props) => props.theme.colors.content.active};
  transform: translateY(${(props) => props.yVal ?? '0'}px);
  transition: transform 0.6s ease;
`;
